import { c as _c } from "react/compiler-runtime";
import { AIRDROPS_USE_CASE } from "@/components/delegation/delegation-constants";
import { MEMES_CONTRACT } from "@/constants/constants";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
interface AirdropAddress {
  address: string;
  ens: string;
}
export interface AirdropAddressResult {
  tdh_wallet: AirdropAddress;
  airdrop_address: AirdropAddress;
}
export default function UserPageSubscriptionsAirdropAddress(props) {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row className="pb-2"><Col className="d-flex align-items-center gap-2"><h5 className="no-wrap mb-0">Airdrop Address</h5></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.airdrop) {
    t1 = props.airdrop?.airdrop_address && <><><span data-tooltip-id={`airdrop-address-${props.airdrop.airdrop_address.address}`}>{props.airdrop.airdrop_address.address}</span><Tooltip id={`airdrop-address-${props.airdrop.airdrop_address.address}`} style={{
          backgroundColor: "#1F2937",
          color: "white",
          padding: "4px 8px"
        }}>{props.airdrop.airdrop_address.address}</Tooltip></>{props.airdrop.airdrop_address.ens && <span> - {props.airdrop.airdrop_address.ens}</span>}</>;
    $[1] = props.airdrop;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span>{t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.airdrop?.airdrop_address || $[6] !== props.show_edit) {
    t3 = props.airdrop?.airdrop_address && props.show_edit && <a href={`/delegation/register-delegation?collection=${MEMES_CONTRACT}&use_case=${AIRDROPS_USE_CASE.use_case}`} aria-label="Change airdrop address"><FontAwesomeIcon icon={faEdit} /></a>;
    $[5] = props.airdrop?.airdrop_address;
    $[6] = props.show_edit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Container className="no-padding">{t0}<Row className="pt-1"><Col className="d-flex gap-2">{t2}{t3}</Col></Row></Container>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}